// ============================================================================
// TIMEZONE CONSTANTS
// ============================================================================

export const TIMEZONES = {
  US_EASTERN: 'America/New_York',
  US_CENTRAL: 'America/Chicago',
  US_MOUNTAIN: 'America/Denver',
  US_PACIFIC: 'America/Los_Angeles',
  US_ALASKA: 'America/Anchorage',
  US_HAWAII: 'Pacific/Honolulu',
  UTC: 'UTC',
} as const

/** Common timezones for dropdown selectors */
export const COMMON_TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST)' },
  { value: 'America/Phoenix', label: 'Arizona Time (MST)' },
  { value: 'America/Toronto', label: 'Toronto (ET)' },
  { value: 'America/Vancouver', label: 'Vancouver (PT)' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Paris (CET/CEST)' },
  { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
  { value: 'Asia/Seoul', label: 'Seoul (KST)' },
  { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
  { value: 'Asia/Dubai', label: 'Dubai (GST)' },
  { value: 'Australia/Sydney', label: 'Sydney (AEDT/AEST)' },
  { value: 'UTC', label: 'UTC' },
] as const

/** Compact timezone options for space-constrained UIs */
export const COMPACT_TIMEZONES = [
  { value: 'America/New_York', label: 'ET' },
  { value: 'America/Chicago', label: 'CT' },
  { value: 'America/Denver', label: 'MT' },
  { value: 'America/Los_Angeles', label: 'PT' },
  { value: 'America/Anchorage', label: 'AKT' },
  { value: 'Pacific/Honolulu', label: 'HT' },
  { value: 'Europe/London', label: 'GMT' },
  { value: 'Europe/Paris', label: 'CET' },
  { value: 'Asia/Tokyo', label: 'JST' },
  { value: 'Asia/Seoul', label: 'KST' },
  { value: 'Australia/Sydney', label: 'AEDT' },
  { value: 'UTC', label: 'UTC' },
] as const

// ============================================================================
// DATE FORMAT CONSTANTS
// ============================================================================

export const DATE_FORMATS = {
  // With timezone
  FULL_WITH_TZ: "MMMM d, yyyy 'at' h:mm a zzz",
  MEDIUM_WITH_TZ: 'MMM d, yyyy h:mm a zzz',
  SHORT_WITH_TZ: 'MMM d, h:mm a zzz',

  // Without timezone
  FULL: "MMMM d, yyyy 'at' h:mm a",
  MEDIUM: 'MMM d, yyyy h:mm a',
  SHORT: 'MMM d, h:mm a',

  // Date only
  DATE_FULL: 'MMMM d, yyyy',
  DATE_MEDIUM: 'MMM d, yyyy',
  DATE_SHORT: 'MMM d',

  // Time only
  TIME_12H: 'h:mm a',
  TIME_WITH_TZ: 'h:mm a zzz',
} as const

// ============================================================================
// EVENT DEFAULTS
// ============================================================================

/** Minimum calendar days from today for a valid event date */
export const MIN_EVENT_DAYS = 7

/**
 * Default calendar days from today used when initializing a new event.
 * Intentionally one day above MIN_EVENT_DAYS so the builder opens with a
 * buffer — users can lower it to the minimum without hitting an error immediately.
 */
export const DEFAULT_EVENT_DAYS = 8
